import { Component } from '@angular/core'
import { LogoIconComponent } from './logo-icon.component'

@Component({
  selector: 'app-logo-classic-icon',
  template: `
    <app-logo-icon></app-logo-icon>
    <span class="label">classic</span>
  `,
  styleUrls: ['./logo-icon.component.scss', './logo-classic-icon.component.scss'],
  imports: [LogoIconComponent],
  standalone: true
})
export class LogoClassicIconComponent {}
